(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!customElements.get('model-viewer')) {
      var s = document.createElement('script');
      s.type = 'module';
      s.src = 'https://unpkg.com/@google/model-viewer@3.5.0/dist/model-viewer.min.js';
      document.head.appendChild(s);
    }

    class Card3dSwap extends HTMLElement {
      connectedCallback() {
        this.mv = this.querySelector('model-viewer');
        this.loaded = false;
        this.pendingHex = null;

        try {
          this.bodyColors = JSON.parse(this.dataset.bodyColors || '{}');
        } catch (e) {
          this.bodyColors = {};
        }

        var card = this.closest('product-card');
        if (!card) return;

        var bodyColors = this.bodyColors;

        // Only react to a change that was directly preceded by a real pointer/keyboard
        // interaction on the card. Some third-party swatch apps (and browser autofill)
        // fire a genuinely trusted 'change' on the first option during page load, which
        // isTrusted alone can't distinguish from an actual click.
        var userInteracting = false;
        var armInteraction = () => {
          userInteracting = true;
          setTimeout(() => {
            userInteracting = false;
          }, 500);
        };
        card.addEventListener('pointerdown', armInteraction, true);
        card.addEventListener('keydown', (e) => {
          if (e.key === ' ' || e.key === 'Enter' || e.key.indexOf('Arrow') === 0) armInteraction();
        }, true);

        card.addEventListener('change', (e) => {
          if (!e.isTrusted || !userInteracting) return;
          userInteracting = false;
          var input = e.target;
          if (!input || input.type !== 'radio') return;
          if (!Object.prototype.hasOwnProperty.call(bodyColors, input.value)) return;
          this.activate(input.value);
        });

        this.mv.addEventListener('load', () => {
          this.loaded = true;
          if (this.pendingHex) this.applyHex(this.pendingHex);
        });
      }

      activate(name) {
        var hex = this.bodyColors[name];
        if (!hex) return;

        this.hidden = false;

        if (!this.mv.getAttribute('src')) {
          this.mv.setAttribute('src', this.dataset.glbUrl);
        }

        if (this.loaded) {
          this.applyHex(hex);
        } else {
          this.pendingHex = hex;
        }
      }

      applyHex(hex) {
        var model = this.mv.model;
        if (!model) return;

        var r = parseInt(hex.slice(1, 3), 16) / 255;
        var g = parseInt(hex.slice(3, 5), 16) / 255;
        var b = parseInt(hex.slice(5, 7), 16) / 255;

        model.materials.forEach((mat) => {
          if (mat.name && mat.name !== 'Body') return;
          if (mat.pbrMetallicRoughness) {
            mat.pbrMetallicRoughness.setBaseColorFactor([r, g, b, 1]);
            mat.pbrMetallicRoughness.setMetallicFactor(0);
            mat.pbrMetallicRoughness.setRoughnessFactor(0.55);
          }
        });
      }
    }

    if (!customElements.get('card-3d-swap')) {
      customElements.define('card-3d-swap', Card3dSwap);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
